import { __spreadValues } from './chunk-T36PI2YV.mjs';

// src/helpers/factories/generalFactories.ts
function groupAndCountByIdFactory(entities) {
  const idCountObject = {};
  entities.forEach((entity) => {
    if (idCountObject[entity.id])
      idCountObject[entity.id].count = idCountObject[entity.id].count + 1;
    else {
      idCountObject[entity.id] = __spreadValues({}, entity);
      idCountObject[entity.id].count = 1;
    }
  });
  return idCountObject;
}

export { groupAndCountByIdFactory };
